import {SocialStudiesTakedown} from './../../../../common/components/social-studies-takedown'
import {LoggedRoute} from './../logged-route'
import {
  SocialStudiesArticlePage,
  SocialStudiesArticleReadingAssignmentSessionReportHandler,
  SocialStudiesAssignArticlePage,
  SocialStudiesAssignmentsHandler,
  SocialStudiesListingPageContainer,
  SocialStudiesSearchOrListingPage,
  SocialStudiesUnitPageHandler,
  SocialStudiesWritingAssignmentReportHandler,
  SocialStudiesReportsOverviewHandler,
} from './lazy'

export const routerV2SocialStudies = [
  {
    path: '/social-studies-units/:socialStudiesUnitId/articles/:articleUuid',
    element: (
      <LoggedRoute
        component={() => <SocialStudiesTakedown component={SocialStudiesArticlePage} />}
      />
    ),
  },
  {
    path: '/social-studies/reports/writing/:assignmentId',
    element: <LoggedRoute component={SocialStudiesWritingAssignmentReportHandler} />,
  },
  {
    path: '/social-studies/reports/reading/:assignmentId/students/:studentId',
    element: <LoggedRoute component={SocialStudiesArticleReadingAssignmentSessionReportHandler} />,
  },
  {
    path: '/social-studies-units/:pathSocialStudiesUnitId',
    element: (
      <LoggedRoute
        component={() => <SocialStudiesTakedown component={SocialStudiesUnitPageHandler} />}
      />
    ),
  },
  {
    path: '/social-studies-units/:pathSocialStudiesUnitId/articles/:articleUuid/assign',
    element: (
      <LoggedRoute
        component={() => <SocialStudiesTakedown component={SocialStudiesAssignArticlePage} />}
      />
    ),
  },
  {
    path: '/social-studies-units',
    element: (
      <LoggedRoute
        component={() => <SocialStudiesTakedown component={SocialStudiesListingPageContainer} />}
      />
    ),
  },
  {
    path: '/social-studies/search',
    element: (
      <LoggedRoute
        component={() => <SocialStudiesTakedown component={SocialStudiesSearchOrListingPage} />}
      />
    ),
  },
  {
    path: '/social-studies/assignments',
    element: <LoggedRoute component={SocialStudiesAssignmentsHandler} />,
  },
  {
    path: '/social-studies/reports',
    element: <LoggedRoute component={SocialStudiesReportsOverviewHandler} />,
  },
]
